<div class="ts1-session-remark-modal flex h-full flex-col overflow-hidden">
	<div class="dialog-header">
		<div class="text-base font-bold text-black">{{ data.sessionLabel }}</div>
	</div>
	<div class="dialog-content flex-1">
		<textarea
			[formControl]="remarkControl"
			class="border-bg-grey-20 h-[200px] w-full border p-4"
			placeholder="Enter session details..."
			[maxlength]="maxLength"
		></textarea>
		<p class="mt-1 text-right text-[10px] text-grey-90">
			({{ (remarkControl.value ?? "").length }} / {{ maxLength }})
		</p>
	</div>
	<div class="dialog-footer">
		<button type="button" mat-stroked-button (click)="cancel()">Cancel</button>
		<button type="button" mat-flat-button color="warn" (click)="save()">Save</button>
	</div>
</div>
